import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import AppModal from '@/core/components/AppModal.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import { Ticket } from '@/modules/ticket/Ticket';

interface TicketViewDoneModalProps {
	ticket: Ticket;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketViewDoneModal',
  props: {
    ticket: {}
  },
  emits: [
	'cancel',
	'requestDone',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cancel = () => {
	emit('cancel');
};

const requestDone = () => {
	emit('requestDone');
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(AppModal, { onClose: cancel }, {
    header: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [
        _createTextVNode(" Klarmarkera ärende #%{ id } ")
      ])), [
        [_directive_translate, {id: props.ticket.id}]
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(requestDone, ["prevent"])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("p", null, [
          _createTextVNode(" Är du säker på att du vill klarmarkera ärende #%{ id }? ")
        ])), [
          [_directive_translate, {id: props.ticket.id}]
        ]),
        _createElementVNode("p", null, [
          _createVNode(AppButton, {
            type: "submit",
            class: "t-success"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Ja, klarmarkera")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            onClick: cancel,
            class: "t-neutral"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})